/* eslint-disable */
export enum ReceptionistDashboardSiderItem {
	HOME = 'Overview',
	GET_STARTED = 'Get Started',
	CRM = 'My Customers',
	SETUP_INSTRUCTIONS = 'Phone Number',
	CONFIGURE = 'Configure',
	TEST_CALL = 'Test Call',
	ANALYTICS = 'Analytics',
	VOICE_LIBRARY = 'Voice Library',
	EMBEDDABLES = 'Website Widget',
	NOTIFICATIONS = 'Notify Me',
	ADVANCED_FEATURES = 'Advanced Features',
	TEXTING_AGENT = 'Texting Agent',
	INTAKE_FORMS = 'Intake Form Logs',
	CALL_LOGS = 'Call Logs',
	ALL_LOGS = 'Inbox',
	LOGS = 'Logs',
	TEXT_LOGS = 'Text Logs',
	VOICE_MAIL_LOGS = 'Voicemail Logs',
	REFERRAL_PROGRAM = 'Referral Program',
	CONTACT_SUPPORT = 'Get Live Help',
	SUBSCRIPTION_MANAGEMENT = 'Subscription',
	RESELLER_SUPPORT_BUTTON_1 = 'Reseller Support Button 1',
	RESELLER_SUPPORT_BUTTON_2 = 'Reseller Support Button 2',
	EXPLORE_FEATURES = 'Explore Features',
	PR_STATS = 'pr-stats',
	PM_METRICS = '/pmmetrics',
	RESELLER_PLAN = 'Plan Subscription',
	ACCOUNT = 'Account',
	SETTINGS = 'Settings',
	PASSWORD = 'Password',
	SUBSCRIPTION = 'Subscription',
	USAGE = 'Usage',
	PREFERENCES = 'Preferences',
	RECEPTIONIST = 'Receptionist',
	LOGOUT = 'Logout',
	CREDITS = 'Credits',
	DASHBOARD = 'Dashboard',
	APPINTEGRATIONS = 'App Integrations',
	HIRE_AI_RECEPTIONIST = 'Hire AI Receptionist',
	GENERAL_SETTINGS = 'General Settings',
	CALENDAR = 'Calendar',
	TICKETS = 'Tickets',
	CELLO_REFERRAL = 'Earn $150',
}
